import type React from 'react';
import { useEntityExplorer } from '../../state/EntityExplorer/useEntityExplorer';
import { EntityDrawer } from './EntityDrawer';

/**
 * Coordinator component that renders all open drawers
 * Should be rendered once in the app root
 */
export const EntityExplorerCoordinator: React.FC = () => {
  const { drawers } = useEntityExplorer();

  if (drawers.length === 0) {
    return null;
  }

  return (
    <>
      {drawers.map((drawer) => (
        <EntityDrawer key={drawer.id} drawer={drawer} />
      ))}
    </>
  );
};
